import 'document-register-element'
import f from 'facon'

class NewsletterForm extends HTMLElement {

  constructor() {
    super()

    this.connectedCallback = this.connectedCallback.bind(this)
    this.valChange = this.valChange.bind(this);
    this.submit = this.submit.bind(this)

    this.form = null
    this.submitUrl = null
    this.consentEl = null
    this.nameEl = null
    this.emailEl = null
    this.buttonEl = null;
    this.honeypotEl = null;
    this.messageEl = null;
    this.loaderEl = null;
    this.disabled = false;
    this.done = false;
  }

  get consent() {
    return this.consentEl.checked||false
  }

  get name() {
    return this.nameEl.value||''
  }

  get email() {
    return this.emailEl.value||''
  }

  get honeypot() {
    return this.honeypotEl.value||'';
  }

  static get tagName() {
    return 'newsletter-form'
  }

  connectedCallback() {
    const agree = this.getAttribute('agree-msg');
    const confirm = this.getAttribute('confirm-msg');
    const domElements = f`
      <style>
        .newsletter-message {
          opacity: 1;
          transition: opacity .35s ease-in;
        }

        .newsletter-message.hidden {
          opacity: 0;
        }

        newsletter-form {
          position: relative;
        }

        newsletter-form form {
          transition: opacity: .35s ease-in, max-height .25s ease-out;
          max-height: 400px;
        }

        newsletter-form form.hidden {
          opacity: 0;
          max-height: 0px;
        }

        newsletter-form .lds-ring .hidden {
          opacity: 0;
        }
      </style>
      <form ref="form" class="newsletter-form">
        <label for="name">Full name</label>
        <input ref="name" id="name" required type="text" name="user_name" placeholder="Full Name"><br>
        <label for="email">Email</label>
        <input ref="email" id="email" required type="email" name="user_email" placeholder="Email"><br>
        <label class="show" for="consent"><input ref="consent" id="consent" required type="checkbox" name="consent"> ${agree}</label>
        <input type="text" ref="honeypot" style="opacity: 0; pointer-events: none; position: absolute;" name="honey_pot">
        <button disabled ref="button" type="submit" name="Submit">Submit</button>
      </form>
      <div ref="loader" class="lds-ring hide"><div></div><div></div><div></div><div></div></div>
      <p class="newsletter-message hidden" ref="message">${confirm}</p>
    `

    const { form, name, email, consent, button, honeypot, message, loader } = domElements.collect()
    this.form = form
    this.consentEl = consent
    this.nameEl = name
    this.emailEl = email
    this.buttonEl = button;
    this.honeypotEl = honeypot;
    this.messageEl = message;
    this.loaderEl = loader;

    this.form.addEventListener('submit', this.submit)
    this.consentEl.addEventListener('change', this.valChange);
    this.emailEl.addEventListener('change', this.valChange);
    this.nameEl.addEventListener('change', this.valChange);

    this.appendChild(domElements)
  }

  valChange() {
    if (this.consentEl.validity.valid &&
        this.nameEl.validity.valid &&
        this.emailEl.validity.valid) {
      this.buttonEl.disabled = false;
    } else {
      this.buttonEl.disabled = true;
    }
  }

  submit(event) {
    event.preventDefault()
    if (this.consent && this.name && this.email) {
      this.form.classList.toggle('hidden');
      this.loaderEl.classList.toggle('hide');
      fetch('/wp-json/onea/v1/newsletter/', {
        method: 'POST',
        body: jQuery.param({
          consent: this.consent,
          name: this.name,
          email: this.email,
          honeypot: this.honeypot,
          referer: window.location.href,
        }),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        },
      }).then((response) => {
        response.json().then((data) => {
          if (data.message === 'ok') {
            this.messageEl.classList.toggle('hidden');
            this.loaderEl.classList.toggle('hide');
          }
        });
      })
    }
  }

}

if (customElements.get(NewsletterForm.tagName) === undefined) {
  customElements.define(NewsletterForm.tagName, NewsletterForm)
}

export default NewsletterForm




// WEBPACK FOOTER //
// ./scripts/components/newsletter_form_babel.js